// @ts-check

/**
 * @template {{ (...args: any[]): any }} T
 * @param {T} callback
 * @param {number} wait
 * @returns {T & { cancel: () => void }} }
 */
export function debounce(callback, wait) {
  /** @type {NodeJS.Timeout} */
  let timer;
  const debounced = /** @param {...any} args */
  function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), wait);
  };
  debounced.cancel = () => {
    clearTimeout(timer);
  };
  return /** @type {T & { cancel: () => void }} } */debounced;
}